import PrintRoundedIcon from '@material-ui/icons/PrintRounded';
import PublishIcon from '@material-ui/icons/Publish';
import WebAssetRoundedIcon from '@material-ui/icons/WebAssetRounded';
import React from 'react';
import TableContainer from '../../components/table/TableContainer';
import { handleDownloadExcel } from '../../Utils/MyUtils';

const SaleEndOfDayData = ({ data, columns }) => {
    const downloadExcel = () => {
        handleDownloadExcel(data, 'SHEET_NAME', 'MY_FILENAME');
    };
    return (
        <TableContainer
            columns={columns}
            title={'Báo cáo bán hàng theo thời gian'}
            data={data}
            actions={[
                <button onClick={downloadExcel}>
                    <WebAssetRoundedIcon />
                    <span className="item_title">Xem trước</span>
                </button>,
                <button onClick={downloadExcel}>
                    <PublishIcon />
                    <span className="item_title">Xuất file</span>
                </button>,
                <button onClick={downloadExcel}>
                    <PrintRoundedIcon />
                    <span className="item_title">In</span>
                </button>,
            ]}
        />
    );
};

export default SaleEndOfDayData;
